import React, { useMemo } from 'react';

import { RewardsDetailedPopupTimerOrBudget } from '../../detailed-popup/timer-or-budget';
import { useOutsideClick, useTranslation } from '../../../../../../hooks';
import { dotFormatter } from '../../../../../../helpers';
import { CashbackInfo } from '../../../../../../models';
import { T } from '../../../../../../constants';

import CoinLeft from '../../../../../../assets/images/coint-left.png';
import CoinRight from '../../../../../../assets/images/coin-right.png';

import './style.scss';

interface AnnouncementPopupProps {
  currency: string;
  onClose: () => void;
  cashbackInfo: CashbackInfo;
}

export const AnnouncementPopup: React.FC<AnnouncementPopupProps> = ({
  onClose,
  currency,
  cashbackInfo
}) => {

  const { levels, claimingCountPerUser } = cashbackInfo

  const t = useTranslation();
  const { modalRef, containerRef } = useOutsideClick(onClose);

  const totalRewards = useMemo<number>(() => {
    const total = levels.reduce((acc, { rewardAmount }) => acc + rewardAmount, 0) * claimingCountPerUser;
    return +(total).toFixed();
  }, [levels, claimingCountPerUser]);

  return (
    <div className="announcement-popup-overlay" ref={containerRef}>
      <div className="announcement-popup-holder" ref={modalRef}>
        <div className="announcement-popup-decor">

        </div>
        <div className="announcement-popup-wrapper">
          <div className="announcement-popup-head-img" />
          <button type='button' className="announcement-popup-close" onClick={onClose}>
            <i className="icon-close " />
          </button>
          <div className="announcement-popup-content">
            <div className="announcement-popup-header">
              <p className="announcement-popup-name">{t(T.UNLOCK_YOUR)}</p>
              <p className="announcement-popup-title">{t(T.PASCAL_REWARDS)}</p>
            </div>

            <div className="announcement-popup-section">
              <p className="announcement-popup-name-title">{t(T.TOTAL_REWARDS_UP_TO)}</p>
              <p className="announcement-popup-amount">{dotFormatter(totalRewards)} {currency}</p>
            </div>

            <div className="announcement-popup-calendar">
              <RewardsDetailedPopupTimerOrBudget
                data={cashbackInfo}
                currencyCode={currency}
              />
            </div>

            <div className="announcement-popup-info">
              <p className="announcement-popup-info-name">{t(T.PLAY)}</p>
              <p className="announcement-popup-info-name">{t(T.LEVEL_UP)}</p>
              <p className="announcement-popup-info-name">{t(T.WIN_REWARDS)}</p>
            </div>

            <button type='button' className="announcement-popup-button" onClick={onClose}>
              {t(T.START_PASCAL_REWARDS)}
            </button>
          </div>
        </div>

        <div className="announcement-popup-coin-container">
          <img src={CoinLeft} alt="coin" className="announcement-popup-coin" />
          <img src={CoinRight} alt="coin" className="announcement-popup-coin" />
        </div>
      </div>
    </div>
  );
};
